import {FormControl} from 'platform/components';
import {UseDocumentPreviewReturnType} from 'platform/document-preview';

import {useMemo} from 'react';
import {useFieldArray, UseFormReturn} from 'react-hook-form';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';
import {DeliveryNoteField} from '../types/DeliveryNoteField';
import {ListOfItemsHeader} from './ListOfItemsHeader';
import {ListOfItemsTable} from './ListOfItemsTable';
import {ListOfItemsTotalPriceWithPagination} from './ListOfItemsTotalPriceWithPagination';

interface ListOfItemsWrapperProps {
  isConfirmed: boolean;
  isLoadingSuggestions: boolean;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  formApi: UseFormReturn<DeliveryNoteDocumentPreviewFormDefinition>;
  documentPreview: UseDocumentPreviewReturnType;
}

export function ListOfItemsWrapper(props: ListOfItemsWrapperProps) {
  const {fields} = useFieldArray({control: props.control, name: 'listOfItems'});

  const currentPage = props.documentPreview.state.activeIndex + 1;

  const {availablePages, currentPageItems} = useMemo(() => {
    const pageNumbers = new Set<number>();
    const itemsForCurrentPage: DeliveryNoteField[] = [];

    fields.forEach((field, index) => {
      pageNumbers.add(field.pageNumber);

      if (field.pageNumber === currentPage) {
        itemsForCurrentPage.push({field, originalIndex: index});
      }
    });

    return {
      availablePages: Array.from(pageNumbers).sort((a, b) => a - b),
      currentPageItems: itemsForCurrentPage,
    };
  }, [fields, currentPage]);

  const hasMoreThanOnePage = availablePages.length > 1;

  return (
    <>
      <ListOfItemsHeader
        isConfirmed={props.isConfirmed}
        isLoadingSuggestions={props.isLoadingSuggestions}
        formApi={props.formApi}
        control={props.control}
        pageNumber={currentPage}
        hasMoreThanOnePage={hasMoreThanOnePage}
        documentPreview={props.documentPreview}
      />
      <ListOfItemsTable
        isConfirmed={props.isConfirmed}
        isLoadingSuggestions={props.isLoadingSuggestions}
        isCollapsed={props.documentPreview.state.isCollapsed}
        formApi={props.formApi}
        control={props.control}
        currentPage={currentPage}
        currentPageItems={currentPageItems}
      />
      <ListOfItemsTotalPriceWithPagination
        isConfirmed={props.isConfirmed}
        control={props.control}
        documentPreview={props.documentPreview}
        availablePages={availablePages}
        currentPage={currentPage}
        hasMoreThanOnePage={hasMoreThanOnePage}
      />
    </>
  );
}
